import React, { useState, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { StoresContext } from './Context/Stores'
import SVG from './SVG'
import YesOrNo from './YesOrNo'

const Store = ({ store, history }) => {
  const storesCtx = useContext(StoresContext)

  const [showYesOrNo, setShowYesOrNo] = useState(false)

  const isSelectedStore = store.bc_hash === storesCtx.store.bc_hash
  const selectedChannel = storesCtx.channel

  const confirmDelete = () => {
    setShowYesOrNo(true)
  }

  const deleteThis = () => {
    setShowYesOrNo(false)
    storesCtx.deleteStore(store.bc_hash)
  }

  return (
    <>
      <div className="my-1 p-4 w-full rounded-lg relative border-2 text-left transition border-gray-100 bg-white hover:bg-gray-50">
        <div className="flex items-center">
          <div>
            <div className="text-xl font-medium">{store.bc_name}</div>
            {/* <div className="text-sm text-gray-400">{store.bc_url}</div> */}
            {store?.summary && (
              <div className="text-sm text-gray-400">
                {/* brands ({store.summary.brands_count?.toLocaleString()}) categories (
                {store.summary.categories_count?.toLocaleString()})  */}
                SKUs: {store.summary.variant_count?.toLocaleString()}
              </div>
            )}
          </div>
          <div
            onClick={confirmDelete}
            className="cursor-pointer ml-auto flex items-center text-gray-300 hover:text-red-500"
          >
            <SVG name="trash" className="h-6 w-6" />
          </div>
        </div>
      </div>
      {showYesOrNo && (
        <YesOrNo
          title="Revoke access to store"
          message={`Are you sure you want to revoke your access to ${store.bc_name}`}
          doYes={deleteThis}
          showMe={setShowYesOrNo}
        />
      )}
    </>
  )
}

export default withRouter(Store)
